import React from "react";
import { Offcanvas } from "react-bootstrap";

const OffCanvas = ({ show, onHide, children, title, className, iconClassName, specialityBodyClassName }) => {
  return (
    <Offcanvas show={show} onHide={onHide} placement="end">
      <Offcanvas.Header className={className}>
        <Offcanvas.Title>{title}</Offcanvas.Title>
      </Offcanvas.Header>
      <div>
        <div className=" offcanvas-container position-relative ">
          <div className={iconClassName ? iconClassName : "d-flex justify-content-center offcanvas-arrow position-absolute "} onClick={onHide}>
            <i className="ri-arrow-right-s-line"></i>
          </div>
        </div>
      </div>
      <Offcanvas.Body className={specialityBodyClassName}>{children}</Offcanvas.Body>
    </Offcanvas>
  );
};
export default OffCanvas;
